import { worldchain as viemWorldchain } from 'viem/chains';

import { defaultServices } from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const worldchain = {
  displayName: 'World Chain',
  runtime: 'evm',
  viemChain: viemWorldchain,
  isSupported: false,
  isMainnet: true,
  services: defaultServices({
    zerion: { chainKey: 'world' },
    qnStreams: {
      networkKey: 'worldchain-mainnet',
    },
    pimlico: { chainSlug: 'worldchain' },
  }),
} as const satisfies AllChainConfig<'evm', false>;
